import React, { useEffect, useState } from 'react';
import axios from 'axios';

const UserManagement = () => {
  const [users, setUsers] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUsers = async () => {
      const token = localStorage.getItem('token');
      try {
        const response = await axios.get(`${window.location.protocol}//${window.location.hostname}/api/users`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setUsers(response.data);
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to fetch users');
      }
    };

    fetchUsers();
  }, []);

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
      <h2 className="text-xl font-semibold mb-3">User Management</h2>
      {error && <p className="text-sm text-red-600 mb-3">{error}</p>}
      <table className="min-w-full divide-y divide-slate-200 text-sm">
        <thead>
          <tr>
            <th className="px-3 py-2 text-left text-slate-600">ID</th>
            <th className="px-3 py-2 text-left text-slate-600">Username</th>
            <th className="px-3 py-2 text-left text-slate-600">Email</th>
            <th className="px-3 py-2 text-left text-slate-600">Role</th>
            <th className="px-3 py-2 text-left text-slate-600">Active</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-100">
          {users.map((user) => (
            <tr key={user.id}>
              <td className="px-3 py-2">{user.id}</td>
              <td className="px-3 py-2">{user.username}</td>
              <td className="px-3 py-2">{user.email}</td>
              <td className="px-3 py-2 capitalize">{user.role}</td>
              <td className="px-3 py-2">{user.isActive ? 'Yes' : 'No'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default UserManagement;
